module.exports = __webpack_public_path__ + "static/media/test6_4.de3045e9.png";